export const MODAL_ROOT_KEY_ELEMENT_ID = '__modal_root_key_id__';
